import Grid, { GridProps } from '@mui/material/Grid';
import { FC, ReactNode } from 'react';

interface IProps extends GridProps {
  children: ReactNode;
  className?: string;
}

export const GridLayout: FC<IProps> = ({
  children,
  className,
  ...otherProps
}) => {
  return (
    <Grid className={className} {...otherProps}>
      {children}
    </Grid>
  );
};
